import { z } from "zod";

export const sessionRatingSchema = z.object({
  id: z.number(),
  session_id: z.string(),
  vote: z.enum(["up", "down"]),
  reason: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const sessionRatingUpsertSchema = z.object({
  vote: z.enum(["up", "down"]),
  reason: z.string().max(200).nullable().optional(),
});

export type SessionRating = z.infer<typeof sessionRatingSchema>;
export type SessionRatingUpsert = z.infer<typeof sessionRatingUpsertSchema>;
